"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegotiationStatus = void 0;
var NegotiationStatus;
(function (NegotiationStatus) {
    NegotiationStatus["NOT_YET_COMPLETE"] = "NOT_YET_COMPLETE";
    NegotiationStatus["REJECTED"] = "REJECTED";
    NegotiationStatus["ACCEPTED"] = "ACCEPTED";
})(NegotiationStatus = exports.NegotiationStatus || (exports.NegotiationStatus = {}));
